"use client"

import { useState } from 'react'

interface FrmDashViewOptionsProps {
    setDialogOpen?: (open: boolean) => void;
    selectedViewElements: number;
    setSelectedViewElements: (viewElements: number) => void;
}

const FrmDashViewOptions = ({ setDialogOpen, selectedViewElements, setSelectedViewElements }: FrmDashViewOptionsProps) => {
    const [localSelectedViewElements, setLocalSelectedViewElements] = useState<number>(selectedViewElements);

    function onSubmit() {
        if (localSelectedViewElements === 0) {
            alert("Please select at least one element to view on the dashboard.");
            return;
        }
        setDialogOpen?.(false);
        setSelectedViewElements(localSelectedViewElements);
    }

    return (
        <div className="p-4">
            <div className="mb-4">
                <div key={"radial-overview-1"} className="flex items-center py-2">
                    <input
                        type="checkbox"
                        id={`radial-overview`}
                        className="checkbox-default"
                        checked={(localSelectedViewElements & 1) === 1}
                        onChange={(e) => {
                            if (e.target.checked) {
                                setLocalSelectedViewElements(localSelectedViewElements + 1);
                            } else {
                                setLocalSelectedViewElements(localSelectedViewElements - 1);
                            }
                        }}
                    />
                    <label htmlFor={`radial-overview`} className="text-base cursor-pointer flex-1">Overview Radial</label>
                </div>
            </div>
            <div className="mb-4">
                <div key={"riskIssueSupport-overview-2"} className="flex items-center py-2">
                    <input
                        type="checkbox"
                        id={`riskIssueSupport-overview`}
                        className="checkbox-default"
                        checked={(localSelectedViewElements & 2) === 2}
                        onChange={(e) => {
                            if (e.target.checked) {
                                setLocalSelectedViewElements(localSelectedViewElements + 2);
                            } else {
                                setLocalSelectedViewElements(localSelectedViewElements - 2);
                            }
                        }}
                    />
                    <label htmlFor={`riskIssueSupport-overview`} className="text-base cursor-pointer flex-1">Risks, Issues & Support</label>
                </div>
            </div>
            <div className="mb-4">
                <div key={"health-overview-4"} className="flex items-center py-2">
                    <input
                        type="checkbox"
                        id={`health-overview`}
                        className="checkbox-default"
                        checked={(localSelectedViewElements & 4) === 4}
                        onChange={(e) => {
                            if (e.target.checked) {
                                setLocalSelectedViewElements(localSelectedViewElements + 4);
                            } else {
                                setLocalSelectedViewElements(localSelectedViewElements - 4);
                            }
                        }}
                    />
                    <label htmlFor={`health-overview`} className="text-base cursor-pointer flex-1">Overall Health</label>
                </div>
            </div>
            <div className="mb-4">
                <div key={"project-progress-8"} className="flex items-center py-2">
                    <input
                        type="checkbox"
                        id={`project-progress`}
                        className="checkbox-default"
                        checked={(localSelectedViewElements & 8) === 8}
                        onChange={(e) => {
                            if (e.target.checked) {
                                setLocalSelectedViewElements(localSelectedViewElements + 8);
                            } else {
                                setLocalSelectedViewElements(localSelectedViewElements - 8);
                            }
                        }}
                    />
                    <label htmlFor={`project-progress`} className="text-base cursor-pointer flex-1">Project Progress</label>
                </div>
            </div>
            <div className="mb-4">
                <div key={"project-health-16"} className="flex items-center py-2">
                    <input
                        type="checkbox"
                        id={`project-health`}
                        className="checkbox-default"
                        checked={(localSelectedViewElements & 16) === 16}
                        onChange={(e) => {
                            if (e.target.checked) {
                                setLocalSelectedViewElements(localSelectedViewElements + 16);
                            } else {
                                setLocalSelectedViewElements(localSelectedViewElements - 16);
                            }
                        }}
                    />
                    <label htmlFor={`project-health`} className="text-base cursor-pointer flex-1">Project Health</label>
                </div>
            </div>
            <div className="flex justify-end">
                <button
                    onClick={onSubmit}
                    className="button-default mx-auto"
                >
                    Update Dashboard
                </button>
            </div>
        </div>
    )
}

export default FrmDashViewOptions;